<template>
	<div
		class="category-card relative hover:opacity-80 min-w-[176px] w-full"
		:class="category.aspectRatio || 'aspect-square'"
	>
		<NuxtImg
			:src="category.Files[0]?.ImagePath + '?w=250&h=250&format=webp'"
			:alt="$t('image_fallback_category_named', { name: category.Name })"
			class="object-cover object-center absolute w-full h-full"
			draggable="false"
			:loading="lazyLoading ? 'lazy' : 'eager'"
			:preload="!lazyLoading"
		/>
	</div>
	<span class="category-card__name">{{ category.Name }}</span>
	<span
		v-if="category.buttonText"
		class="category-card__button mt-2 block w-fit border border-current px-6 py-3 text-sm font-medium"
	>
		{{ category.buttonText }}
	</span>
</template>

<script setup lang="ts">
// `category-card`, `category-card__name` and `category-card__button` are
// styling hooks
// (styled in promix and aworldofcraft).
import type { CategoryWithFiles } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";

interface Props {
	category: CategoryWithFiles & {
		aspectRatio?: string | null;
		buttonText?: string;
	};
	lazyLoading: boolean | undefined;
}

defineProps<Props>();
</script>
